import { getLoggedUserRoles } from './token';

const userHasRole = async (role) => {
  const userRoles = await getLoggedUserRoles();
  if (!role) return false;
  return userRoles.includes(role);
};

export {
  userHasRole,
};
